import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import TransactionLookupDatatable from "./TransactionLookupDatatable";

function TransactionLookupTabs(props) {
    const [activeTab, setActiveTab] = useState(1);
    const [path, setPath] = useState();
    const history = useHistory();
    const location = useLocation();
    const tabs = [
        {
            name: "Transaction Lookup",
            path: "/transactionLookup",
        }
    ];
    useEffect(() => {
        setPath(location.pathname);
    }, [location.pathname]);

    const renderTab = () => {
        if (path === "/transactionLookup") {
            return <TransactionLookupDatatable/>;
        }
    }

    return (
        <>
            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                {tabs.map((tab, index) => (
                    <li className="nav-item">
                        <a
                            className={`nav-link ${path === tab.path && "active"}`}
                            data-toggle="tab"
                            href="#"
                            role="tab"
                            onClick={() => history.push(`${tab.path}`,{from:window.location.href})}
                        >
              <span className="d-block d-sm-none">
                <i className="fas fa-address-card"></i>
              </span>
                            <span
                                className="d-none d-sm-block"
                                style={{ whiteSpace: "pre-line" }}
                            >
                {tab.name}
              </span>
                        </a>
                    </li>
                ))}
            </ul>
            <div className="tab-pane" role="tabpanel">
                {renderTab()}
            </div>
        </>
    );
}

export default TransactionLookupTabs;
